// test1082
(1082 && 0);
